import type { Color, TextType, Weight } from '../types/legacyTheme';

export const gray = {
  0: '#FFFFFF',
  100: '#F6F6F6',
  200: '#E4E4E4',
  300: '#DDDDDD',
  400: '#CCCCCC',
  500: '#AAAAAA',
  600: '#707070',
  700: '#575757',
  800: '#2D2D2D',
  900: '#191919',
};

export const color: Color = {
  gray,
  green: {
    dark: '#19CE60',
    default: '#00FFC2',
  },
  option: {
    facebook: '#5A68EA',
    instagram: '#E80186',
    naver: '#00E717',
    youtube: '#FF0000',
  },
  primary: {
    dark: '#035BAB',
    default: '#0D71CC',
    light: '#6EC1FF',
    lighter: '#DEECF6',
  },
  red: {
    dark: '#DC0000',
    default: '#F15153',
    light: '#FF3F6E',
  },
  yellow: {
    dark: '#FE9000',
    default: '#F6AB00',
    light: '#FFE600',
    lighter: '#FCFAE2',
  },
};

export const text: TextType = {
  size10: {
    fontSize: '0.5rem',
    lineHeight: '0.7rem',
  },
  size12: {
    fontSize: '0.6rem',
    lineHeight: '0.9rem',
  },
  size14: {
    fontSize: '0.7rem',
    lineHeight: '1rem',
  },
  size16: {
    fontSize: '0.8rem',
    lineHeight: '1.2rem',
  },
  size18: {
    fontSize: '0.9rem',
    lineHeight: '1.4rem',
  },
  size20: {
    fontSize: ' 1rem',
    lineHeight: '1.4rem',
  },
  size24: {
    fontSize: '1.2rem',
    lineHeight: '1.7rem',
  },
  size28: {
    fontSize: '1.4rem',
    lineHeight: '1.9rem',
  },
  size32: {
    fontSize: '1.6rem',
    lineHeight: '2rem',
  },
};

export const weight: Weight = {
  bold: {
    fontWeight: 700,
  },
  medium: {
    fontWeight: 500,
  },
};
